import React, { useEffect, useState } from 'react'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import '../../style/style.css'

function DigitalProps(props) {

  const [propsItems, setPropsItem] = useState([])
  const [submitClose, setSubmitClose] = useState(false)
  const [digitalProp, setDigitalProp] = useState([])
  const [loading, setLoading] = useState(false)

  const DigitalPropsItems = async () => {
    try {
      setLoading(true)
      await http.get("event-props").then((res) => {
        if (res.data.prop_digital) {
          let responseData = [];
          res.data.prop_digital.forEach(props=>{
            let manipulateData = {
              ...props,
              selectedAll: false
            }
            responseData.push(manipulateData)
          })
          
          setDigitalProp(responseData)
          
          setLoading(false)
        }
      }).catch((err) => {
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (propsItems) {
      props.setData(propsItems)
    }
  }

  useEffect(() => {
    DigitalPropsItems()
  }, [])

  useEffect(() => {
    if (propsItems.length != props.digitalPropsItem.length) {
      setPropsItem(props.digitalPropsItem)
    }

    // if (props.digitalPropsItem.length > 0) {
    //   if (digitalProp.length > 0) {
    //     let copyDigitalProp = [...digitalProp]
    //     let ids = []
    //     props.digitalPropsItem.forEach(item=>{
    //       ids.push(item.id)
    //     })
  
    //     copyDigitalProp = copyDigitalProp.forEach(propList=>{
    //       let propItem = propList.prop
    //       for (let i = 0; i < propItem.length; i++) {
    //         if (ids.includes(propItem[i].id)) {
    //           propList.selectedAll = true
    //           break;
    //         }
    //       }
    //     })
    //     setDigitalProp(copyDigitalProp)
    //   }
    // }

  }, [props])

  

  const changeValue = (item) => {

    let copyItem = [...propsItems]
    let IndexOfItem = copyItem.findIndex(data => data.id === item.id)

    if (IndexOfItem >= 0) {
      copyItem.splice(IndexOfItem, 1)
      setPropsItem(copyItem)
    }
    else {
      copyItem = [...copyItem, item]
      setPropsItem(copyItem)
    }

    if (copyItem.length > 0) {
      setSubmitClose(true)
    }
    else {
      setSubmitClose(false)
    }

  }


  const selectAllData = (index) => {
    let copyData = [...digitalProp]
    let choosenData = copyData[index] 
    let copyItem = [...propsItems]

    if (!choosenData.selectedAll) {
      choosenData.prop.forEach(prop => {
        let item = { id: prop.id, image: prop.prop }

        let IndexOfItem = copyItem.findIndex(data => data.id === item.id)

        if (IndexOfItem < 0) {
          copyItem = [...copyItem, item]
          setPropsItem(copyItem)
        }
      })

      choosenData.selectedAll = true;
      copyData[index] = choosenData
      setDigitalProp(copyData)
      
    }
    else{
      choosenData.prop.forEach(prop => {
        let item = { id: prop.id, image: prop.prop }

        let IndexOfItem = copyItem.findIndex(data => data.id === item.id)

        if (IndexOfItem >= 0) {
          copyItem.splice(IndexOfItem, 1)
          setPropsItem(copyItem)
        }
      })

      choosenData.selectedAll = false;
      copyData[index] = choosenData
      setDigitalProp(copyData)
    }

    if (copyItem.length > 0) {
      setSubmitClose(true)
    }
    else {
      setSubmitClose(false)
    }

    
  }


  return (
    <div className="modal fade" id="digital-props-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Select Digital Props</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">	<span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="modal-tab-header">
              <ul className="mb-3 nav nav-pills justify-content-around" id="digital-props-tab" role="tablist">
                {
                  digitalProp &&
                  digitalProp.map((propCategory, index) => (
                    <li className="nav-item" role="presentation" key={`prop-category-index-${index}`}>
                      <span
                        className={`tab-item ${index === 0 && 'active'}`}
                        id={`digital-props-${index}-tab`}
                        href={`#digital-props-${index}`}
                        role="tab"
                        data-toggle="tab"
                        aria-controls={`digital-props-${index}`}
                        aria-selected="false"
                      >
                        {propCategory.category_name}
                      </span>
                    </li>
                  ))
                }


              </ul>
            </div>
            <div className="tab-content template-content" id="digital-props-tabContent">

              {
                !loading ?
                  digitalProp &&
                  digitalProp.map((propCategory, index) => (
                    <div
                      className={`tab-pane fade show ${index === 0 && 'active'}`}
                      id={`digital-props-${index}`}
                      role="tabpanel"
                      aria-labelledby={`digital-props-${index}-tab`}
                      key={`digital-prop-tab-${index}`}
                    >
                      <div className="standared-template">
                        <div className="row">

                          {
                            propCategory.prop.length > 0 ?
                              propCategory.prop.map((items) => {
                                return (
                                  <div key={items.id} className="my-2 col-md-2" onClick={e => changeValue({ id: items.id, image: items.prop })}>
                                    <div className={`template-item ${propsItems && propsItems.findIndex(item => item.id === items.id) >= 0 && 'active-template'}`}>
                                      <img src={`${URL_S3}image/digital_prop/${items.prop}`} alt="template-1" className="img-fluid" />
                                    </div>
                                  </div>
                                )
                              })
                              :
                              <div className="col-12">
                                <h4 className="text-secondary text-center text-uppercase font-weight-lighter">No Props Found</h4>
                              </div>
                          }
                        </div>

                      </div>

                      <div className="modal-footer justify-content-between">
                        <div className="left-alignment">
                          <button type="button" className="px-5 m-1 btn btn-secondary radius-30" onClick={selectAllData.bind(this, index)}>
                            {
                              !propCategory.selectedAll
                              ? "Select All"
                              : "Remove All"
                            }
                          </button>
                        </div>
                        <div className="right-alignment">
                          <button type="button" className="px-5 m-1 btn btn-secondary radius-30" data-dismiss="modal">Close</button>
                          <button type="button" className="px-5 m-1 btn btn-primary radius-30" onClick={handleSubmit} data-dismiss={submitClose && "modal"}>Save changes</button>
                        </div>
                      </div>

                    </div>

                  ))
                  :
                  <div className="text-center col-md-12">
                    <span className="spinner-border" role="status" aria-hidden="true"></span>
                  </div>
              }

            </div>
          </div>
          
        </div>
      </div>
    </div>
  )
}

export default DigitalProps
